import React, { Fragment } from "react";
import Form from "./form";
import EntityComponent from "../../../../common/entity-component";

import config from "./config";
import Customer from "../../../../../types/Customer";
import ExportExcel from "./components/ExportExcel";

export default function CustomersFragment({
  customers,
  isMobile,
  actions,
  removeCustomer,
  onEditCustomer,
  onCreateCustomer,
  onSetFreeAccess,
}) {
  let tabConfig = !isMobile ? config.tabConfig : config.mobileTabConfig;

  const onCreateStore = async (customer: Customer) => {
    await onCreateCustomer(customer);
  };
  const onRemoveCustomer = async (customer: Customer) => {
    removeCustomer(customer.id);
  };

  return (
    <Fragment>
      <EntityComponent
        canBeRemoved={true}
        canBeEdited={true}
        canBeCreated={true}
        tabConfig={tabConfig}
        filterConfig={config.filterConfig}
        onRemoveItem={onRemoveCustomer}
        singularEntityName="Customer"
        pluralEntityName="Customers"
        dataset={customers}
        ExtraComponent={(values) => <ExportExcel {...values}></ExportExcel>}
        onEditItem={onEditCustomer}
        onCreateItem={onCreateStore}
        Form={(props) => (
          <Form
            {...props}
            actions={actions}
            customers={customers}
            onSetFreeAccess={onSetFreeAccess}
          />
        )}
      />
    </Fragment>
  );
}
